module.exports = __webpack_public_path__ + "img/candi-nav-2.63f6a434.svg";